/** Tab „Desktop-App": Download der Windows-App (nur im Browser sichtbar, nicht in der App selbst). */
import { DESKTOP_DOWNLOAD_URL } from '../../lib/desktopApp';

export function DesktopAppTab() {
  return (
    <div className="lf-settings-sections">
      <section className="lf-settings-card stack" aria-labelledby="desktop-app-heading">
        <h2 id="desktop-app-heading">Lagerfeuer Desktop für Windows</h2>
        <p>
          Lagerfeuer und Discord in einem Fenster – nebeneinander oder als Tabs, mit Ungelesen-Zähler in der Taskleiste,
          Benachrichtigungen und automatischen Updates.
        </p>
        <p>
          <a className="btn btn-primary" href={DESKTOP_DOWNLOAD_URL} download data-testid="desktop-download">
            Desktop-App für Windows herunterladen
          </a>
        </p>
        <p className="small muted">
          Windows 10/11 (64 Bit), Installation ohne Administratorrechte. Beim ersten Start meldet Windows SmartScreen
          „Unbekannter Herausgeber“ (die App ist nicht signiert): „Weitere Informationen“ → „Trotzdem ausführen“.
        </p>
      </section>
    </div>
  );
}
